import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BidConfirmationModalType } from '../types/auction';
import convertToCurrency from './convertToCurrency';

const getModalProperties = (
  confirmationTypes,
  index,
  onConfirmModal,
  onCancelModal,
  quickBidAmount
) => {
  return {
    onConfirm: () => () => {
      if (index + 1 === confirmationTypes.length)
        onConfirmModal(quickBidAmount);
    },
    confirmLabel: <FormattedMessage id="vdp.confirmation.yesBid" />,
    onCancel: () => onCancelModal,
    cancelLabel: <FormattedMessage id="modal.cancel" />
  };
};

const getModalLogic = modalDetails => {
  const {
    confirmationTypesList,
    confirmationModalLogic: setConfirmModalLogic,
    bid: bidAmount,
    proxy: proxyAmount,
    confirmModal: onConfirmModal,
    cancelModal: onCancelModal,
    quickBidAmount
  } = modalDetails;

  if (confirmationTypesList?.length) {
    confirmationTypesList?.forEach((type, index) => {
      const {
        onConfirm,
        confirmLabel,
        onCancel,
        cancelLabel
      } = getModalProperties(
        confirmationTypesList,
        index,
        onConfirmModal,
        onCancelModal,
        quickBidAmount
      );

      switch (type) {
        case BidConfirmationModalType.legal:
          setConfirmModalLogic(modal =>
            modal.concat([
              {
                title: (
                  <FormattedMessage id="modal.confirmation.confirmYourBid.title" />
                ),
                msg: (
                  <FormattedMessage id="modal.confirmation.confirmYourBid.description" />
                ),
                onConfirm,
                confirmLabel,
                onCancel,
                cancelLabel
              }
            ])
          );
          break;
        case BidConfirmationModalType.overBidThreshold:
          setConfirmModalLogic(modal =>
            modal.concat([
              {
                title: (
                  <FormattedMessage
                    id={
                      proxyAmount
                        ? 'vdp.confirmation.title.startingBidSeemsHigh'
                        : 'vdp.confirmation.title.bidSeemsHigh'
                    }
                    values={{ bidAmount: convertToCurrency(bidAmount) }}
                  />
                ),
                msg: (
                  <FormattedMessage
                    id="vdp.confirmation.msg.confirmBidAmount"
                    values={{ bidAmount: convertToCurrency(bidAmount) }}
                  />
                ),
                onConfirm,
                confirmLabel,
                onCancel,
                cancelLabel
              }
            ])
          );
          break;
        case BidConfirmationModalType.overProxyThreshold:
          setConfirmModalLogic(modal =>
            modal.concat([
              {
                title: (
                  <FormattedMessage
                    id="vdp.confirmation.title.proxySeemsHigh"
                    values={{ proxyAmount: convertToCurrency(proxyAmount) }}
                  />
                ),
                msg: (
                  <FormattedMessage
                    id="vdp.confirmation.msg.confirmProxyAmount"
                    values={{ proxyAmount: convertToCurrency(proxyAmount) }}
                  />
                ),
                onConfirm,
                confirmLabel,
                onCancel,
                cancelLabel
              }
            ])
          );
          break;
        case BidConfirmationModalType.outbidDGN:
          setConfirmModalLogic(modal =>
            modal.concat([
              {
                title: (
                  <FormattedMessage id="vdp.confirmation.title.sameDealerGroup" />
                ),
                msg: <FormattedMessage id="vdp.confirmation.msg.submitBid" />,
                onConfirm,
                confirmLabel,
                onCancel,
                cancelLabel
              }
            ])
          );
          break;
        case BidConfirmationModalType.outbidDealership:
          setConfirmModalLogic(modal =>
            modal.concat([
              {
                title: (
                  <FormattedMessage id="vdp.confirmation.title.sameDealership" />
                ),
                msg: <FormattedMessage id="vdp.confirmation.msg.submitBid" />,
                onConfirm,
                confirmLabel,
                onCancel,
                cancelLabel
              }
            ])
          );
          break;
        default:
          break;
      }
    });
  }
};

export default getModalLogic;
